// TODO: Refactor to remove select2 dependency
export function importSelect2() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://dvh1deh6tagwk.cloudfront.net/dependencies/js/select2/4.0.3/dist/js/select2.full.min.js';
    script.async = false;
    script.addEventListener('load', resolve);
    script.addEventListener('error', () => reject('Error loading select2 script.'));

    const stylesLink = document.createElement('link');
    stylesLink.rel = 'stylesheet';
    stylesLink.type = 'text/css';
    stylesLink.href = 'https://dvh1deh6tagwk.cloudfront.net/dependencies/js/select2/4.0.3/dist/css/select2.min.css';

    document.head.appendChild(script);
    document.head.appendChild(stylesLink);
  });
}

// Moved from static-old
export function initSelect2() {
  const $allNotBoundSelect2 = $('.select2:not([data-select2-bound])');

  $allNotBoundSelect2.each(function bindSelect2() {
    const $el = $(this);
    let doHighlight = true;

    if ($el.data('highlight-terms') !== undefined) {
      doHighlight = $el.data('highlight-terms');
    }
    $el.attr('data-select2-bound', 'true').data('search-query', {
      term: '',
      _type: 'query'
    }).select2({
      width: '100%',
      templateResult: function templateResult(item) {
        if (item.loading || item.children) {
          return item.text;
        }

        const data = $(item.element).closest('select').data() || {};
        let result = '';
        if (typeof data.overrideTemplateResult !== 'undefined') {
          if (typeof window[data.overrideTemplateResult] === 'function') {
            result = window[data.overrideTemplateResult].apply(this, arguments);
          }
        } else {
          result = $.fn.select2.defaults.defaults.templateResult.apply(this, arguments);
        }
        const term = $el.data('search-query').term;

        if (doHighlight && term) {
          const searchTerm = (term).replace(
            /[-[\]/{}()*+?.\\^$|]/g,
            '\\$&'
          );

          const re = new RegExp(`{([^}]*?)(${searchTerm})(.*?)?}`, ['gi']);
          result = result.replace(re, '$1<span class="select--search-term-match">$2</span>$3');
        }

        return result.replace(/({|})/g, '');
      },
      templateSelection: function templateSelection(item) {
        if (item.loading || item.children) {
          return item.text;
        }
        const data = $(item.element).closest('select').data() || {};
        if (typeof data.overrideTemplateSelection !== 'undefined') {
          if (typeof window[data.overrideTemplateSelection] === 'function') {
            return window[data.overrideTemplateSelection].apply(this, arguments);
          }
        }
        return $.fn.select2.defaults.defaults.templateResult.apply(this, arguments);
      },
      language: {
        searching: function searching(params) {
          $el.data('search-query', params);

          // Change this to be appropriate for your application
          return 'Searching…';
        }
      },
      escapeMarkup: function escapeMarkup(markup) {
        return markup;
      }
    });
  });

  $allNotBoundSelect2.on('select2:open', function fixDropdownWidthBelowMediumScreenWidth(event) {
    const MEDIUM_SCREEN_SIZE = 971;
    const currentSelect2Widget = $(event.currentTarget).data('select2');
    const $dropdown = currentSelect2Widget.$dropdown;
    const $select = currentSelect2Widget.$element;

    if ($(window).width() <= MEDIUM_SCREEN_SIZE) {
      $dropdown.addClass('select2-override');
      const maxWidth = $select.parent()[0].getBoundingClientRect().width;
      $dropdown.css('width', `${maxWidth}px`);
    }
  });
}
